import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FeaturesJrRakuPack } from '@travel/icons/features';
import { ArrowLeft } from '@travel/icons/ui';
import { Translate } from '@travel/translation';
import { useDeviceTypes } from '@travel/traveler-core/hooks';
import { IconText } from '@travel/ui';
import { cx } from '@travel/utils';

import ImageGallery from 'components/ImageGallery';

import { pushLocation } from 'store/__router/actions';

import paths from 'constants/paths';

import { getQueryString } from 'store/__router/selectors';

import styles from './planInfo.module.scss';

type Props = {
  hotelId: string;
};

const PlanInfoSkeleton = (props: Props) => {
  const { hotelId } = props;

  const { isPC } = useDeviceTypes();
  const dispatch = useDispatch();
  const search = useSelector(getQueryString);

  const goToPlanList = () =>
    dispatch(pushLocation(`${paths.plansList.pathResolver(hotelId)}${search}`));

  return (
    <div className={styles.container}>
      <div className={styles.titleHeader}>
        <IconText
          className={styles.planListLink}
          text={<Translate id="Plan_List.Detail.Back_To_List" />}
          icon={<ArrowLeft size={16} className={styles.arrowLeft} />}
          spaceBetween={4}
          width={8}
          textClassName={styles.linkText}
          height={16}
          onClick={goToPlanList}
          data-testid="PlanInfo-backPlanList"
        />
        <FeaturesJrRakuPack className={styles.jrRakuPack} />
      </div>
      {!isPC && (
        <ImageGallery
          media={[]}
          galleryType="slide"
          mediaLimit={3}
          className={styles.imageGallery}
          galleryClassName={styles.imageWrapper}
          isTitle
          mediaTitleClass={styles.mediaSlideTitle}
        />
      )}
      <div className={cx(styles.planName, styles.planNameSkeleton)} />
      <div className={styles.splitContent}>
        <div className={styles.planDetails}>
          <div className={styles.planFeatures}>
            <div className={styles.planFeatureSkeleton} />
            <span className={styles.divider} />
            <div className={styles.planFeatureSkeleton} />
            <span className={styles.divider} />
            <div className={styles.planFeatureSkeleton} />
          </div>
          <p className={styles.descriptionSkeleton} />
          <Translate className={styles.noBedNotice} id="Plan_List.Detail.Infant_No_Bed.Notice" />
        </div>
        {isPC && (
          <ImageGallery
            media={[]}
            galleryType="thumbnail"
            mediaLimit={3}
            swiperClassName={styles.imageGalleryPC}
            className={styles.imageGalleryPC}
            galleryClassName={styles.imageWrapper}
            thumbnailClass={styles.galleryThumbnail}
            mediaTitleClass={styles.mediaTitle}
            isTitle
          />
        )}
      </div>
    </div>
  );
};

export default PlanInfoSkeleton;
